export const PAGES_SERVICES_PATHS = {
  access_denied: '403',
};
